import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { SubscriptionCardLoadingDesktop } from './Desktop';
import { SubscriptionCardLoadingMobile } from './Mobile';
import { SubscriptionCardLoadingTablet } from './Tablet';

export const SubscriptionCardLoading: React.FC = (props) => {
  const responsiveItem = useBreakpointValue({
    base: <SubscriptionCardLoadingMobile {...props} />,
    sm: <SubscriptionCardLoadingTablet {...props} />,
    lg: <SubscriptionCardLoadingDesktop {...props} />,
  });

  return responsiveItem;
};
